module.exports = __webpack_public_path__ + "img/signal_wifi_4_bar-black.4810e4de.svg";